import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import Breadcrumb from "../components/BreadCrumb";
import SoftwareDevSection from "../components/sections/SoftwareDev";
import TechnologiesSection from "../components/sections/Technologies";
import DevProcessSection from "../components/sections/DevProcess";
import OurWorksSection from "../components/sections/OurWorks";
import CaseStudiesSection from "../components/sections/CaseStudies";
import TestimonialsSection from "../components/sections/Testimonials";
import CTASection from "../components/sections/CTA";
import Contact from "../components/sections/Contact";
import SoftwareDevContactForm from "../components/sections/SoftwareDevContactForm";

const SoftwareDevelopment = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const paths = [
    { label: t("home"), link: "/" },
    { label: t("software_development"), link: "/software-development" },
  ];

  return (
    <div className="w-full min-h-screen bg-black text-white">
      {/* Include all software development related sections */}
      <SoftwareDevSection />
      <TechnologiesSection />
      <DevProcessSection />
      <OurWorksSection />
      {/* <CaseStudiesSection /> */}
      {/* <TestimonialsSection /> */}
      <CTASection />
      <SoftwareDevContactForm />
    </div>
  );
};

export default SoftwareDevelopment;
